import template from './products.html';
import controller from './productsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    productsData: '<',
    familyId: '<',
  },
};
